module.exports = __webpack_public_path__ + "images/meru.963e3a1af38b318715f331fae8be3283.png";